module.exports = __webpack_public_path__ + "media/images/CWDA_logo-1ba19b26bdd19e46c483a77de06f2813.jpg";